import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ecclesia_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("ecclesia_user");
      localStorage.removeItem("ecclesia_token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Auth
export const authAPI = {
  login: (data) => api.post("/auth/login", data),
  register: (data) => api.post("/auth/register", data),
};

// Bautizos
export const bautizosAPI = {
  getAll: (params) => api.get("/bautizos", { params }),
  getOne: (id) => api.get(`/bautizos/${id}`),
  create: (data) => api.post("/bautizos", data),
  update: (id, data) => api.put(`/bautizos/${id}`, data),
  delete: (id) => api.delete(`/bautizos/${id}`),
};

// Matrimonios
export const matrimoniosAPI = {
  getAll: (params) => api.get("/matrimonios", { params }),
  getOne: (id) => api.get(`/matrimonios/${id}`),
  create: (data) => api.post("/matrimonios", data),
  update: (id, data) => api.put(`/matrimonios/${id}`, data),
  delete: (id) => api.delete(`/matrimonios/${id}`),
};

// Confirmaciones
export const confirmacionesAPI = {
  getAll: (params) => api.get("/confirmaciones", { params }),
  getOne: (id) => api.get(`/confirmaciones/${id}`),
  create: (data) => api.post("/confirmaciones", data),
  update: (id, data) => api.put(`/confirmaciones/${id}`, data),
  delete: (id) => api.delete(`/confirmaciones/${id}`),
};

// Personas
export const personasAPI = {
  getAll: (params) => api.get("/personas", { params }),
  getOne: (id) => api.get(`/personas/${id}`),
  create: (data) => api.post("/personas", data),
  update: (id, data) => api.put(`/personas/${id}`, data),
  delete: (id) => api.delete(`/personas/${id}`),
};

// Ministerios
export const ministeriosAPI = {
  getAll: () => api.get("/ministerios"),
  getOne: (id) => api.get(`/ministerios/${id}`),
  getMiembros: (id) => api.get(`/ministerios/${id}/miembros`),
  create: (data) => api.post("/ministerios", data),
  update: (id, data) => api.put(`/ministerios/${id}`, data),
  delete: (id) => api.delete(`/ministerios/${id}`),
  addMiembro: (id, personaId) => api.post(`/ministerios/${id}/miembros/${personaId}`),
  removeMiembro: (id, personaId) => api.delete(`/ministerios/${id}/miembros/${personaId}`),
};

// Intenciones
export const intencionesAPI = {
  getAll: (params) => api.get("/intenciones", { params }),
  getOne: (id) => api.get(`/intenciones/${id}`),
  create: (data) => api.post("/intenciones", data),
  update: (id, data) => api.put(`/intenciones/${id}`, data),
  delete: (id) => api.delete(`/intenciones/${id}`),
  marcarCelebrada: (id) => api.put(`/intenciones/${id}/celebrar`),
};

// Parroquias
export const parroquiasAPI = {
  getAll: () => api.get("/parroquias"),
  getOne: (id) => api.get(`/parroquias/${id}`),
  create: (data) => api.post("/parroquias", data),
  update: (id, data) => api.put(`/parroquias/${id}`, data),
  delete: (id) => api.delete(`/parroquias/${id}`),
};

// Dashboard
export const dashboardAPI = {
  getStats: () => api.get("/dashboard/stats"),
};

export default api;
